// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3i9yu","selected":"Chip_selected__3Tusp"};